import React, {ReactNode} from 'react';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import { CardMedia, Theme} from "@material-ui/core";
import {injectIntl, InjectedIntlProps } from 'react-intl';
import CardHeader, {CardHeaderProps} from '@material-ui/core/CardHeader';

import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import SwipeableViews from "react-swipeable-views";
import {CardMediaProps} from "@material-ui/core/CardMedia";
//@ts-ignore
import FloatingCard from '../components/primitives/Card/FloatingCard';
//@ts-ignore
import LoginForm from "./LoginForm";
//@ts-ignore
import SignupForm from "./SignupForm";


const styles = (theme: Theme) => ({
  card: {
    width: 320,
  },
});

interface State {
  index: number;
}

interface AuthCardProps extends WithStyles<typeof styles>, InjectedIntlProps {
  image?: object;
  headerProps?: CardHeaderProps;
  mediaProps?: CardMediaProps;
  encrypt?: boolean
}

class AuthCard extends React.Component<AuthCardProps, State> {
  constructor(props: AuthCardProps) {
    super(props);
    this.state = {
      index: 0,
    };
  }

  handleChange = (event: any, index: number) => {
    this.setState({ index });
  };

  handleChangeIndex = (index: number) => {
    this.setState({ index: index });
  };

  render() {
    const { classes, headerProps, mediaProps, intl, encrypt } = this.props;
    const { index } = this.state;
    const header = headerProps ? <CardHeader {...headerProps} /> : null;
    const image = mediaProps ? <CardMedia {...mediaProps} /> : null;
    let first, second = null;
    if (index === 0) {
      first = <LoginForm encrypt={encrypt}/>;
    } else {
      second = <SignupForm encrypt={encrypt}/>;
    }
    return (
      <FloatingCard className={classes.card}>
        {header}
        {image}
        <AppBar position="static" color="default">
          <Tabs value={index} onChange={this.handleChange} centered variant="fullWidth">
            <Tab label={intl.formatMessage({ id: 'login' })} />
            <Tab label={intl.formatMessage({ id: 'signup' })} />
          </Tabs>
        </AppBar>
        {index === 0 && first}
        {index === 1 && second}
      </FloatingCard>
    );
  }
}

export default withStyles(styles)(injectIntl(AuthCard));
